<script>
    export default {
        name: "ProductNotification",
        props: {
            notification: Object,
        },
        methods: {
            openModal() {
                const { title, text } = this.notification;
                this.$popup.show("modal-safety-rules", {
                    title,
                    text,
                });
            },
        },
    };
</script>

<template>
    <div class="product-notification" @click="openModal">
        <div class="product-notification__icon">
            <img src="/static/miku-kz/icons/rules.svg" alt="" />
        </div>
        <div class="product-notification__text" v-html="notification.announcement"></div>
    </div>
</template>

<style lang="scss">
    .product-notification {
        position: relative;
        display: flex;
        align-items: center;
        margin-bottom: 32px;
        padding: 24px;
        background: #fff7f6;
        border-radius: 15px;
        @include bp($bp-desktop-sm) {
            max-width: 448px;
            border-radius: 20px;
            cursor: pointer;
        }
    }

    .product-notification__icon {
        position: absolute;
        top: -10px;
        left: -10px;
        display: flex;
        align-items: center;
        justify-content: center;
        @include box(32px);
        border-radius: 50%;
        background-color: var(--danger);
        @include bp($bp-desktop-sm) {
            @include box(40px);
            top: -20px;
            left: -20px;
        }
    }

    .product-notification__text {
        font-size: 14px;
        font-weight: 500;
        line-height: 22px;
        span {
            position: relative;
            color: #fa1a1a;
            font-weight: 600;
            &::after {
                content: "";
                display: inline-block;
                @include box(14px);
                background-image: url("data:image/svg+xml, %3Csvg width='14' height='14' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M11.05 2.95c.3.3.3.8 0 1.1l-7 7a.78.78 0 1 1-1.1-1.1l7-7c.3-.3.8-.3 1.1 0Z' fill='%23FA0F0C' /%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M3.89 3.5c0-.43.35-.78.78-.78h5.83c.43 0 .78.35.78.78v5.83a.78.78 0 1 1-1.56 0V4.28H4.67a.78.78 0 0 1-.78-.78Z' fill='%23FA0F0C' /%3E%3C/svg%3E");
                vertical-align: middle;
            }
        }
        svg {
            vertical-align: middle;
        }
    }
</style>
